import { render, staticRenderFns } from "./UploadFileDiCambio.vue?vue&type=template&id=b9edba28&"
import script from "./UploadFileDiCambio.vue?vue&type=script&lang=js&"
export * from "./UploadFileDiCambio.vue?vue&type=script&lang=js&"
import style0 from "./UploadFileDiCambio.vue?vue&type=style&index=0&id=b9edba28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer})
